import React from 'react';
import AddOnCard from './AddOns/AddOnCard';

type ServiceProviderAnalyticsCardV2Props = {
  hasOTT: boolean;
  hasCDN: boolean;
  hasMarketIntel: boolean;
  zIndex: number;
};
const ServiceProviderAnalyticsCardV2 = ({
  hasOTT,
  hasCDN,
  hasMarketIntel,
  zIndex
}: ServiceProviderAnalyticsCardV2Props) => {
  const spaInfo = { title: 'Service Provider Analytics', description: 'SP-ANALYTICS' };
  const spaExtensions = [
    {
      key: 'OTT Service Tracking',
      value: hasOTT ? 'Enabled' : 'Disabled'
    },
    {
      key: 'CDN Analytics',
      value: hasCDN ? 'Enabled' : 'Disabled'
    },
    {
      key: 'Market Intelligence',
      value: hasMarketIntel ? 'Enabled' : 'Disabled'
    }
  ];

  return (
    <AddOnCard title={spaInfo.title} description={spaInfo.description} extensions={spaExtensions} zIndex={zIndex} />
  );
};

export default ServiceProviderAnalyticsCardV2;
